import React, { Suspense } from 'react';

import { Objectives as ObjectivesView } from '@modules/Objectives/views/Objectives';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';


export const Objectives: React.FC = () => {

  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%"/>}>
        <ObjectivesView/>
      </Suspense>
    </ErrorBoundary>
  );
};
